<script setup>
import UiButton from '@/components/ui/UiButton.vue'

/**
 * The two ways to add to a section of related records, the same in every one: "New" makes a
 * record (in the panel from the right, linked here once saved), "Link existing" finds one made
 * already. Each with its words, not an icon to guess.
 */
defineProps({ canCreate: Boolean, canLink: Boolean, linking: Boolean, testid: { type: String, default: '' } })
const emit = defineEmits(['create', 'link'])
</script>

<template>
  <div class="flex shrink-0 items-center gap-1">
    <UiButton v-if="canLink" size="xs" variant="ghost" icon="fa-link" :class="linking ? 'bg-[var(--surface-3)]' : ''" :aria-pressed="linking" :data-testid="testid ? `${testid}-link` : undefined" @click="emit('link')">{{ $t('related.attachExisting') }}</UiButton>
    <UiButton v-if="canCreate" size="xs" variant="ghost" icon="fa-plus" :data-testid="testid ? `${testid}-new` : undefined" @click="emit('create')">{{ $t('related.new') }}</UiButton>
  </div>
</template>
